{
  "version": 1,
  "asset_id": "892a214a-2127-44bb-a39c-ec16ed67e82f",
  "project_id": "ba939065-ecb3-4567-a218-3200eee84f15",
  "url": "/__l5e/assets-v1/892a214a-2127-44bb-a39c-ec16ed67e82f/form-8857.jpg",
  "r2_key": "a/v1/ba939065-ecb3-4567-a218-3200eee84f15/892a214a-2127-44bb-a39c-ec16ed67e82f/form-8857.jpg",
  "original_filename": "form-8857.jpg",
  "size": 187237,
  "content_type": "image/jpeg",
  "created_at": "2026-06-15T15:39:17Z"
}
